import LazyImages from './LazyImages';
export default (($) => {
    console.log('UNTUCKit : Module : Article : loaded');
    const $window = $(window), $articleBody = $('.article-body'), $articleTables = $articleBody.find('table'), $stlImages = $articleBody.find('img.shop-the-look-image'), $blogContainer = $('#blog-collection__article-container');
    function getMoreArticles() {
        const $next = $('.js-next');
        const getURL = $next.attr('data-paginate');
        $.get(getURL, function (data) {
            const $returnWrapper = $('<div/>').append(data);
            const $newArticles = $returnWrapper
                .find('#blog-grid__article-container')
                .children();
            $('#blog-grid__article-container').append($newArticles);
            const hasNext = $returnWrapper.find('.js-next').length;
            // Either update the load button with new data for next load or remove button
            if (hasNext) {
                const newNextData = $returnWrapper.find('.js-next').attr('data-paginate');
                $('.js-next').attr('data-paginate', newNextData);
            }
            else {
                $('.js-next').remove();
            }
            LazyImages.update();
        });
    }
    /**
     * Function to get img and data elements from tables in article body
     */
    function getArticleTableData($e) {
        const tableData = [];
        // Traverse the rows
        $e.find('tr').each(function () {
            const shopLookObj = {};
            // Traverse the row data
            $(this)
                .find('td')
                .each(function (i, td) {
                const tableData = $(td);
                const imgCheck = tableData.find('img').attr('src');
                // Table data can be an image or text, check then add ot our object
                if (imgCheck) {
                    shopLookObj.lookImage = imgCheck;
                }
                else {
                    shopLookObj.lookProducts = tableData.text();
                }
            });
            tableData.push(shopLookObj);
        });
        return tableData;
    }
    /**
     * Function to get img and data elements from tables in article body
     */
    function getArticleSTLImageData($e) {
        const stlImageData = [];
        const shopLookObj = {};
        const products = $e.attr('products');
        const image_src = $e.attr('src');
        stlImageData.lookImage = image_src;
        if (products) {
            shopLookObj.lookProducts = $e.attr('products');
            stlImageData.push(shopLookObj);
        }
        console.log(shopLookObj);
        // Traverse the rows
        /*
        $e.find('tr').each(function(i) {
          const shopLookObj = {};
    
          // Traverse the row data
          $(this).find('td').each(function(i, td){
            const tableData = $(td);
            const imgCheck = tableData.find('img').attr('src');
    
            // Table data can be an image or text, check then add ot our object
            if(imgCheck) {
              shopLookObj.lookImage = imgCheck;
            }else {
              shopLookObj.lookProducts = tableData.text();
            }
          });
    
          tableData.push(shopLookObj);
        });
        */
        return stlImageData;
    }
    /**
     * Used to build the Shop The Look Markup
     */
    function buildTheLook(arr) {
        const length = arr.length;
        const stlContainer = $('<div/>', {
            class: `shop-the-look-container shop-the-look-${length}`,
        });
        for (let i = 0; i < length; i++) {
            const imgSrc = arr[i].lookImage, products = arr[i].lookProducts;
            const imgBlock = $('<div/>', {
                class: 'shop-the-look__look-item-img',
            }).css('background-image', `url(${imgSrc})`);
            imgBlock.append('<p class="js-open-stl">Shop The Look</p>');
            const shopItemWrapper = $('<div/>', {
                class: 'shop-the-look__item-wrapper',
            }).append(imgBlock);
            shopItemWrapper.append('<div class="stl-scroll"><span class="down-arrow"></span></div>');
            const shopItemsContainer = $('<div/>', {
                class: 'shop-the-look__items-container',
            });
            shopItemsContainer.append('<p class="js-close-stl">&times;</p>');
            shopItemsContainer.append();
            stlContainer.append(shopItemWrapper);
            shopItemWrapper.append(shopItemsContainer);
            //Make Ajax Call And Append To Img Block
            appendStlItems(shopItemsContainer, products);
        }
        return stlContainer;
    }
    function buildTheLookDrawer(arr) {
        const length = arr.length;
        const drawerContainer = $('<div/>', {
            class: 'shop-the-look-drawer',
        });
        const drawerCloseObject = $('<span/>', {
            class: 'shop-the-look-drawer-close',
        });
        for (let i = 0; i < length; i++) {
            const products = arr[i].lookProducts;
            const shopItemsContainer = $('<div/>', {
                class: `shop-the-look-drawer-items item-count-${products.split(',').length}`,
            });
            drawerContainer.append(shopItemsContainer);
            appendStlItems(shopItemsContainer, products);
        }
        drawerContainer.append('<div class="stl-divider"></div>');
        drawerContainer.append(drawerCloseObject);
        return drawerContainer;
    }
    function appendStlItems(e, productList) {
        // No Products Return
        if (!productList) {
            return;
        }
        const productItems = productList.split(',');
        $.each(productItems, function (key, item) {
            // Makes an external request to the shop the look article template
            const requestUrl = `/products/${item}?view=stl`;
            $.get(requestUrl, function (res) {
                e.append(res);
                LazyImages.update();
            });
        });
    }
    function close($e) {
        const itemWrapper = $e.closest('.shop-the-look__items-container');
        if ($window.width() <= 480) {
            itemWrapper.slideUp();
        }
        else {
            itemWrapper.animate({
                height: '0',
                padding: '0',
                borderWidth: '0',
            }, 300);
        }
        $e
            .closest('.shop-the-look__item-wrapper')
            .find('.stl-scroll')
            .removeClass('active');
    }
    function open($e) {
        const itemWrapper = $e
            .closest('.shop-the-look__item-wrapper')
            .find('.shop-the-look__items-container');
        if ($window.width() <= 480) {
            itemWrapper.css({
                height: '100%',
                padding: '10px 10px 5px',
                borderWidth: '1px',
                display: 'none',
            });
            itemWrapper.slideDown();
        }
        else {
            itemWrapper.show().animate({
                height: '100%',
                padding: '10px 10px 5px',
                borderWidth: '1px',
            }, 300, function () {
                $(this).css('overflow', 'scroll');
            });
        }
        if (itemWrapper.hasScrollBar()) {
            itemWrapper.addClass('active');
        }
    }
    function init() {
        // for sanity
        console.log('UNTUCKit : Module : Article : init');
        //Utility function to check if item has a scroll
        $.fn.hasScrollBar = function () {
            return this.get(0).scrollHeight > 500;
        };
        $('.js-next').on('click', function () {
            getMoreArticles();
        });
        $articleTables.each(function (i, e) {
            const shopObjects = getArticleTableData($(e));
            $(this)
                .parent()
                .empty()
                .append(buildTheLook(shopObjects));
        });
        $stlImages.each(function (i, e) {
            const shopObjects = getArticleSTLImageData($(e));
            const openDrawer = $('<div/>', {
                class: 'shop-the-look-drawer-open',
            })
                .append('<div class="stl-divider"></div>')
                .append('<div class="stl-button"><span>Shop The Look</span><span class="icon-arrow"></span></div>')
                .on('click', function () {
                $(this)
                    .parent()
                    .toggleClass('button-hidden')
                    .find('.shop-the-look-drawer')
                    .slideToggle(300);
            });
            $(this)
                .parent()
                .append(openDrawer)
                .append(buildTheLookDrawer(shopObjects));
        });
        $articleBody.on('click', '.js-close-stl', function () {
            close($(this));
        });
        $articleBody.on('click', '.js-open-stl', function () {
            open($(this));
        });
        $blogContainer.on('click', '.js-blog-next', function () {
            const $this = $(this);
            $this.addClass('is-loading');
            $.get($this.data('href'), function (html) {
                $this.remove();
                $blogContainer.append(html);
                LazyImages.update();
            });
            return false;
        });
    }
    return { init };
})($);
